<script lang="ts">
import { defineComponent as __MACROS_defineComponent } from "vue";
export default /*#__PURE__*/ __MACROS_defineComponent({
  name: 'BlocDropDownDefinitionConventionCo'
});
</script>
<template>
  <ka-container
    code="bloc-drop-down-definition-convention-co"
    :options="options"
    :instance-class="instanceClass"
    :slots="$slots"
    :inner="inner"
    :xs="xs"
    :sm="sm">
    <template #label>
      <slot name="label" />
    </template>
    <!-- Deroule -->
    <ka-container
      code="deroule"
      :options="{
        click: componentInstance.derouleClick,
        $state: { selected: $isEqual(componentInstance.$elements['definition']?.style.hidden, componentInstance.$constants.definitionHidden) }
      }"
      :selected="{ click: componentInstance.derouleClickWhenSelected }">
      <!-- Titre -->
      <ka-container code="titre">
        <ka-text
          code="votre-convention-collective"
          :xs-value="componentInstance.$title.value">
          <h3 v-html="t('blocDropDownDefinitionConventionCo.deroule.titre.votreConventionCollective.value', `Votre convention collective`)" />
        </ka-text>
        <ka-icon
          code="icone-developper-4"
          :options="{ $inheritState: { selected: true } }"
          value="i-fa-solid:angle-down" />
      </ka-container>
    </ka-container>
    <!-- Définition -->
    <ka-container
      code="definition"
      :options="{
        animationIn: `fadeIn`,
        hidden: null
      }">
      <ka-text
        code="la-convention-collective"
        :xs-value="componentInstance.$text.value">
        <span v-html="t('blocDropDownDefinitionConventionCo.definition.laConventionCollective.value', `La convention collective rassemble des règles de droit du travail (contrat, congés, salaires...) applicables à un secteur d'activité. Elle est négociée et conclue par les organisations syndicales représentatives des salariés et par les employeurs.<br> <br>Elle comporte généralement un texte de base, souvent complété par des avenants. Une convention collective permet d’adapter les règles du code du travail aux situations particulières du secteur d'activité concerné.<br> <br>L'intitulé de la convention collective applicable dans l'entreprise doit apparaître sur le bulletin de paie remis à chaque salarié.<br> <br><strong>Votre convention collective détermine l’OPCO auquel votre entreprise est rattachée.</strong>`)" />
      </ka-text>
    </ka-container>
  </ka-container>
</template>

<script setup lang="ts">
import { syncComponentStore } from 'kapix-components-vue3'
import { blocDropDownDefinitionConventionCoComponent } from './store'
import './style.scss'
import './style.custom.scss'


provide('$scoped', '--c35')
const component = blocDropDownDefinitionConventionCoComponent()
const componentInstance = component.newStoreInstance()
const props = withDefaults(defineProps<{
  title?: Nullable<string>
  text?: Nullable<string>
  instanceClass?: Nullable<string>
  options?: Nullable<KeyValuePair>
  sm?: Nullable<KeyValuePair>
  xs?: Nullable<KeyValuePair>
  inner?: Nullable<boolean>
}>(), {
  title: '<strong>1. Se renseigner sans se lancer dans un audit approfondi</strong>',
  text: 'La convention collective rassemble des règles de droit du travail (contrat, congés, salaires...) applicables à un secteur d\'activité. Elle est négociée et conclue par les organisations syndicales représentatives des salariés et par les employeurs.<br> <br>Elle comporte généralement un texte de base, souvent complété par des avenants. Une convention collective permet d’adapter les règles du code du travail aux situations particulières du secteur d\'activité concerné.<br> <br>L\'intitulé de la convention collective applicable dans l\'entreprise doit apparaître sur le bulletin de paie remis à chaque salarié.<br> <br><strong>Votre convention collective détermine l’OPCO auquel votre entreprise est rattachée.</strong>',
  instanceClass: undefined,
  options: undefined,
  sm: undefined,
  xs: undefined,
  inner: undefined
})

const emit = defineEmits([
  'update:title',
  'update:text'
])
componentInstance.$emit = emit

syncComponentStore(componentInstance, {
  props,
  propsToWatch: {
    title: true,
    text: true
  }
})
</script>
